<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-19 17:40:45
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\couponManagement\index.vue
-->
<template>
  <div class="app-container">
    <el-tabs
      v-model="activeIndex"
      type="border-card"
      @tab-click="handleClick"
      v-loading="loading"
      v-tab-change:activeIndex="setActiveName"
    >
      <el-tab-pane label="直播券" name="0">
        <!-- 顶部栏 -->
        <div class="topbar">
          <el-input
            v-model="searchValue"
            size="small"
            placeholder=""
            prefix-icon="el-icon-search"
          />
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click.stop="addLiveCoupon()"
          >
            发放直播券
          </el-button>
        </div>
        <!-- 内容 -->
        <el-table
          :data="liveTableData"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column
            prop="CouponID"
            label="#"
            align="center"
            width="150"
          />
          <el-table-column
            prop="OffeNickname"
            label="赠与者"
            align="center"
            width="200"
          />
          <el-table-column
            prop="BindNickname"
            label="接收者"
            align="center"
            width="200"
          />
          <el-table-column label="创建时间" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.StartTime | formatDateTime }}
            </template>
          </el-table-column>
          <el-table-column label="有效时间" align="center" width="400">
            <template slot-scope="scope">
              <p>{{ scope.row.CreateTime | formatDateTime }} 至</p>
              <p>{{ scope.row.ExpirationTime | formatDateTime }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="EffectiveTimes"
            label="剩余有效次数"
            align="center"
          />
          <el-table-column prop="CouponStatus" label="卡券状态" align="center">
            <template slot-scope="scope">
              <el-tag size="medium" :type="formatCouponType(scope.row)">
                {{ formatCouponStatus(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.stop="editLiveCoupon(scope.$index, scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="small"
                type="danger"
                @click.stop="deleteCoupon(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="currentChange"
        />
      </el-tab-pane>

      <el-tab-pane label="麦粒券" name="1">
        <!-- 顶部栏 -->
        <div class="topbar">
          <el-button-group>
            <el-button
              :type="currentTab === '0' ? 'primary' : ''"
              size="small"
              @click="switchTab('0')"
            >
              卡券记录
            </el-button>
            <el-button
              :type="currentTab === '1' ? 'primary' : ''"
              size="small"
              @click="switchTab('1')"
            >
              申请记录
            </el-button>
            <el-button
              :type="currentTab === '2' ? 'primary' : ''"
              size="small"
              @click="switchTab('2')"
            >
              赠送记录
            </el-button>
          </el-button-group>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click.stop="addIntegralCoupon()"
          >
            发放麦粒券
          </el-button>
        </div>
        <!-- 卡券记录 -->
        <div v-show="currentTab === '0'">
          <el-table
            :data="maiTableData"
            :header-cell-style="{ background: '#F5F7FA' }"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-table-column
              prop="CouponID"
              label="#"
              align="center"
              width="150"
            />
            <el-table-column
              prop="OffeNickname"
              label="赠与者"
              align="center"
              width="200"
            />
            <el-table-column
              prop="BindNickname"
              label="接受者"
              align="center"
              width="200"
            />
            <el-table-column label="创建时间" align="center" width="200">
              <template slot-scope="scope">
                {{ scope.row.CreateTime | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="有效时间" align="center" width="400">
              <template slot-scope="scope">
                <p>{{ scope.row.CreateTime | formatDateTime }} 至</p>
                <p>{{ scope.row.ExpirationTime | formatDateTime }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="UsingType" label="使用类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.UsingType === 0 ? "次数" : "时间" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="CouponStatus"
              label="卡券状态"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag size="medium" :type="formatCouponType(scope.row)">
                  {{ formatCouponStatus(scope.row) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="EffectiveTimes"
              label="剩余有效次数"
              align="center"
              width="150"
            />
            <el-table-column label="操作" align="center" width="250">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click.stop="viewVideo(scope.$index, scope.row)"
                >
                  查看视频
                </el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click.stop="editIntegralCoupon(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click.stop="deleteCoupon(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 申请记录 -->
        <div v-show="currentTab === '1'">
          <el-table
            :data="reqTableData"
            :header-cell-style="{ background: '#F5F7FA' }"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-table-column
              prop="CouponRequestID"
              label="#"
              align="center"
              width="150"
            />
            <el-table-column prop="Nickname" label="申请人" align="center" />
            <el-table-column label="接收人" align="center">
              <template slot-scope="scope">
                {{ scope.row.ObjectFirstName + scope.row.ObjectLastName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="RequestStatus"
              label="请求状态"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.RequestStatus === 0
                    ? "未处理"
                    : scope.row.RequestStatus === 1
                    ? "已接受"
                    : "拒绝"
                }}
              </template>
            </el-table-column>
            <el-table-column prop="IsRead" label="状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.IsRead === true ? "已读" : "未读" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ResourceType"
              label="资源类型"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.ResourceType === 0 ? "视频" : "" }}
              </template>
            </el-table-column>
            <el-table-column label="申请日期" prop="CreateTime" align="center">
              <template slot-scope="scope">
                {{ scope.row.CreateTime | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  :type="scope.row.IsDeleted ? 'warning' : 'danger'"
                  @click="
                    scope.row.IsDeleted
                      ? handleRemoveReqRecord(scope.row, '恢复')
                      : handleRemoveReqRecord(scope.row, '删除')
                  "
                >
                  {{ scope.row.IsDeleted ? "恢复" : "删除" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 赠送记录 -->
        <div v-show="currentTab === '2'">
          <el-table
            :data="sendTableData"
            :header-cell-style="{ background: '#F5F7FA' }"
            style="width: 100%; margin-bottom: 20px"
          >
            <el-table-column
              prop="CouponSendRecordID"
              label="#"
              align="center"
              width="100"
            />
            <el-table-column
              prop="CreateUserID"
              label="赠送人ID"
              align="center"
            />
            <el-table-column
              prop="ObjectUserID"
              label="卡券接收人ID"
              align="center"
            />
            <el-table-column
              prop="ObjectType"
              label="赠送对象类型"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.ObjectType === 0 ? "平台用户" : "邮箱" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ObjectEmail"
              label="接收人邮箱"
              align="center"
            />
            <el-table-column
              prop="CouponStatus"
              label="卡券状态"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.CouponStatus === 0 ? "未领取" : "已领取" }}
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="赠送时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.CreateTime | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  :type="scope.row.IsDeleted ? 'warning' : 'danger'"
                  @click="
                    scope.row.IsDeleted
                      ? handleRemoveSendRecord(scope.row, '恢复')
                      : handleRemoveSendRecord(scope.row, '删除')
                  "
                >
                  {{ scope.row.IsDeleted ? "恢复" : "删除" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="currentChange"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- addLiveCouponDialog -->
    <el-dialog
      title="发放直播券"
      :visible.sync="addLiveCouponDialog"
      width="40%"
    >
      <el-form :model="liveForm">
        <el-form-item label="发放对象" label-width="70px">
          <el-input
            v-model="liveForm.BindUserInfo"
            placeholder="登录名/登录邮箱/手机号/单位/姓/名/昵称"
          />
          <el-button size="small" type="primary" @click="detect()"
            >检测</el-button
          >
        </el-form-item>
        <el-form-item label="有效次数" label-width="70px">
          <el-select v-model="liveForm.DateType" style="width: 100%">
            <el-option label="5次" :value="0" />
            <el-option label="10次" :value="1" />
            <el-option label="20次" :value="2" />
            <el-option label="50次" :value="3" />
            <el-option label="100次" :value="4" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addLiveCouponDialog = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="commitLiveCoupon()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- editLiveCouponDialog -->
    <el-dialog
      title="编辑直播券"
      :visible.sync="editLiveCouponDialog"
      width="40%"
    >
      <el-form :model="liveForm">
        <el-form-item label="有效次数" label-width="70px">
          <el-select v-model="liveForm.DateType" style="width: 100%">
            <el-option label="5次" :value="0" />
            <el-option label="10次" :value="1" />
            <el-option label="20次" :value="2" />
            <el-option label="50次" :value="3" />
            <el-option label="100次" :value="4" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editLiveCouponDialog = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="commitLiveCoupon()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- addIntegralCouponDialog -->
    <el-dialog
      title="发放麦粒券"
      :visible.sync="addIntegralCouponDialog"
      width="40%"
    >
      <el-form :model="videoForm">
        <el-form-item label="发放对象" label-width="70px">
          <el-input
            v-model="videoForm.userInfo"
            placeholder="登录名/登录邮箱/手机号/单位/姓/名/昵称"
          />
          <el-button size="small" type="primary" @click="detect1()"
            >检测</el-button
          >
        </el-form-item>
        <el-form-item label="生效方式" label-width="70px">
          <el-select v-model="videoForm.UsingType" style="width: 100%">
            <el-option label="次数" :value="0" />
            <el-option label="时间" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 0"
          label="有效次数"
          label-width="70px"
        >
          <el-input v-model="videoForm.Times"></el-input>
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 1"
          label="开始时间"
          label-width="70px"
        >
          <el-date-picker
            v-model="videoForm.StartTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 1"
          label="结束时间"
          label-width="70px"
        >
          <el-date-picker
            v-model="videoForm.EndTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="视频ID" label-width="70px">
          <el-input v-model="videoForm.VideoIDs" />
          <div>分享的资源id集合，多个资源用","隔开</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addIntegralCouponDialog = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="commitVideoCoupon()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- editIntegralCouponDialog -->
    <el-dialog
      title="编辑麦粒券"
      :visible.sync="editIntegralCouponDialog"
      width="40%"
    >
      <el-form :model="videoForm">
        <el-form-item label="生效方式" label-width="70px">
          <el-select v-model="videoForm.UsingType" style="width: 100%">
            <el-option label="次数" :value="0" />
            <el-option label="时间" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 0"
          label="有效次数"
          label-width="70px"
        >
          <el-input v-model="videoForm.Times"></el-input>
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 1"
          label="开始时间"
          label-width="70px"
        >
          <el-date-picker
            v-model="videoForm.StartTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item
          v-show="videoForm.UsingType === 1"
          label="结束时间"
          label-width="70px"
        >
          <el-date-picker
            v-model="videoForm.EndTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editIntegralCouponDialog = false">
          取 消
        </el-button>
        <el-button size="small" type="primary" @click="commitVideoCoupon()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 预览 -->
    <el-dialog title="查看视频详情" :visible.sync="viewVideoDialog">
      <el-table :data="videoList" border>
        <el-table-column label="#" prop="VideoID"></el-table-column>
        <el-table-column label="视频标题" prop="VideoName"></el-table-column>
        <el-table-column label="视频源">
          <template slot-scope="scope">
            <video
              :src="videoUrl(scope.$index, scope.row)"
              controls
              style="width: 100%; height: 20vh"
            ></video>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCouponList,
  getCouponReqList,
  getCardGiftRecord,
  deleteCoupon,
  switchCouponReqRecord,
  switchCardGiftRecord,
  addLiveCoupon,
  addVideoCoupon,
} from "@/api/mai/couponsManagement/couponsManagement";
import { getAllUserList } from "@/api/userManagement";
export default {
  data() {
    return {
      loading: false,
      searchValue: "",
      activeIndex: "0",
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      addLiveCouponDialog: false,
      editLiveCouponDialog: false,
      liveTableData: [], // 直播券列表
      maiTableData: [], // 麦粒券列表
      reqTableData: [], // 申请记录列表
      sendTableData: [], // 赠送记录列表
      liveForm: {},
      videoForm: { UsingType: 0 },
      currentTab: "0",
      addIntegralCouponDialog: false,
      editIntegralCouponDialog: false,
      viewVideoDialog: false,
      videoSrc: "",
      videoList: [],
      setLiveForm: {},
    };
  },
  computed: {
    videoUrl: {
      get() {
        return function (index, row) {
          return process.env.VUE_APP_RESOURCES + row.VideoUrl;
        };
      },
    },
    formatCouponType() {
      return (row) => {
        switch (row.CouponStatus) {
          case 0:
            return "";
            break;
          case 1:
            return "primary";
            break;
          case 2:
            return "success";
            break;
          case 3:
            return "danger";
            break;
          case 4:
            return "info";
            break;
          case 5:
            return "warning";
        }
      };
    },
    formatCouponStatus() {
      return (row) => {
        switch (row.CouponStatus) {
          case 0:
            return "新增";
            break;
          case 1:
            return "使用中";
            break;
          case 2:
            return "即将过期";
            break;
          case 3:
            return "已使用";
            break;
          case 4:
            return "已过期";
            break;
          case 5:
            return "未使用";
        }
      };
    },
  },
  created() {
    this.refreshCurrentList();
  },
  methods: {
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      switch (this.activeIndex) {
        case "0":
          this.getLiveCouponList();
          break;
        case "1":
          switch (this.currentTab) {
            case "0":
              this.getMaiCouponList();
              break;
            case "1":
              this.getCouponReqList();
              break;
            case "2":
              this.getCardGiftRecord();
          }
      }
    },
    /**
     * 切换tab
     */
    handleClick() {
      this.currentPage = 1;
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 翻页
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },
    /**
     * @description: 检测用户信息
     * @param {*}
     * @return {*}
     */
    detect() {
      if (!this.liveForm.BindUserInfo) {
        this.$message({
          type: "warning",
          message: "请输入数据",
        });
      } else {
        const params = {
          UserDataType: 2,
          keyWord: this.liveForm.BindUserInfo,
        };
        getAllUserList(params).then((res) => {
          if (res.Total !== 1) {
            this.$message({
              type: "error",
              message: "请输入完整的对象信息",
            });
          } else {
            this.$message({
              type: "success",
              message: "检测到用户信息",
            });
            this.liveForm.BindUserInfo = res.Rows[0].Nickname;
            this.liveForm.BindUserID = res.Rows[0].UserID;
          }
        });
      }
      /**
       *       if (!this.formData.expertInfo) {
        this.$message({
          type: "warning",
          message: "请输入数据",
        });
      } else {
        const params = {
          Account: this.formData.expertInfo,
        };
        getExpertInfo(params).then((res) => {
          if (res.isError) {
            this.$message({
              type: "error",
              message: res.errorMessage,
            });
          } else {
            this.$message({
              type: "success",
              message: "用户存在",
            });
            this.formData.expertInfo = res.resultData.CreateUserID;
            this.hasExpert = true;
          }
        });
      }
       */
    },
    detect1() {
      if (!this.videoForm.userInfo) {
        this.$message({
          type: "warning",
          message: "请输入数据",
        });
      } else {
        const params = {
          UserDataType: 2,
          keyWord: this.videoForm.userInfo,
        };
        getAllUserList(params).then((res) => {
          if (res.Total !== 1) {
            this.$message({
              type: "error",
              message: "请输入完整的对象信息",
            });
          } else {
            this.$message({
              type: "success",
              message: "检测到用户信息",
            });
            this.videoForm.userInfo = res.Rows[0].Nickname;
            this.videoForm.ObjectUserID = res.Rows[0].UserID;
          }
        });
      }
    },
    /**
     * @description: 获取直播券列表
     * @param {*}
     * @return {*}
     */
    getLiveCouponList() {
      this.loading = true;
      const params = {
        type: 0,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };
      getCouponList(params)
        .then((res) => {
          this.liveTableData = res.Rows;
          this.totalCount = res.Total;
          // this.currentPage = curPage
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "获取数据失败",
          });
          this.loading = false;
        });
    },
    /**
     * @description: 获取麦粒券列表
     * @param {*}
     * @return {*}
     */
    getMaiCouponList() {
      this.loading = true;
      const params = {
        type: 1,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };
      getCouponList(params)
        .then((res) => {
          this.maiTableData = res.Rows;
          this.totalCount = res.Total;
          // this.currentPage = curPage
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "获取数据失败",
          });
          this.loading = false;
        });
    },
    /**
     * @description: 获取麦粒券申请列表
     * @param {*}
     * @return {*}
     */
    getCouponReqList() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };
      getCouponReqList(params)
        .then((res) => {
          this.reqTableData = res.Rows;
          this.totalCount = res.Total;
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "获取数据失败",
          });
          this.loading = false;
        });
    },
    /**
     * @description: 获取麦粒券赠送列表
     * @param {*}
     * @return {*}
     */
    getCardGiftRecord() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };
      getCardGiftRecord(params)
        .then((res) => {
          this.sendTableData = res.Rows;
          this.totalCount = res.Total;
          this.loading = false;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "获取数据失败",
          });
          this.loading = false;
        });
    },
    /**
     *
     */
    addLiveCoupon() {
      this.addLiveCouponDialog = true;
    },
    /**
     * 编辑直播券
     */
    editLiveCoupon(index, row) {
      let { CouponID, BindUserID } = row;
      this.liveForm = {
        CouponID,
        BindUserID,
      };
      console.log(this.liveForm);
      this.editLiveCouponDialog = true;
    },
    /**
     * @description: 提交直播券
     * @param {*}
     * @return {*}
     */
    commitLiveCoupon() {
      console.log("this.liveForm", this.liveForm);
      if (this.liveForm.CouponID === undefined) this.liveForm.CouponID = 0;
      const data = this.liveForm;
      console.log(data);
      addLiveCoupon(data)
        .then((res) => {
          this.$message({
            type: "success",
            message: res.errorMessage,
          });
          this.editLiveCouponDialog = false;
          this.addLiveCouponDialog = false;
          this.refreshCurrentList();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "提交失败",
          });
          this.editLiveCouponDialog = false;
          this.addLiveCouponDialog = false;
        });
    },
    /**
     *
     */
    switchTab(index) {
      this.currentTab = index;
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     *
     */
    addIntegralCoupon() {
      this.addIntegralCouponDialog = true;
    },

    /**
     * 查看视频
     */
    viewVideo(index, row) {
      if (!row.VideoList) {
        this.$message({
          type: "error",
          message: "没有视频",
        });
      } else {
        this.videoList = row.VideoList;
        this.videoSrc = this.videoList[0].VideoUrl;
        this.viewVideoDialog = true;
      }
    },

    /**
     * 编辑麦粒券
     */
    editIntegralCoupon(index, row) {
      let { CouponID, UsingType, Times, StartTime, EndTime } = row;
      this.videoForm = {
        CouponID,
        UsingType,
        Times,
        StartTime,
        EndTime,
      };
      console.log(this.videoForm);
      this.editIntegralCouponDialog = true;
    },
    /**
     * 提交麦粒券
     */
    commitVideoCoupon() {
      console.log("this.videoForm", this.videoForm);
      if (this.videoForm.CouponID === undefined) this.videoForm.CouponID = 0;
      const data = this.videoForm;
      console.log(data);
      addVideoCoupon(data)
        .then((res) => {
          this.$message({
            type: "success",
            message: res.errorMessage,
          });
          this.editIntegralCouponDialog = false;
          this.addIntegralCouponDialog = false;
          this.refreshCurrentList();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "提交失败",
          });
          this.editIntegralCouponDialog = false;
          this.addIntegralCouponDialog = false;
        });
    },
    /**
     * 删除券
     */
    deleteCoupon(index, row) {
      console.log(index, row);
      this.$confirm("是否删除该券", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const data = {
            CouponID: row.CouponID,
          };
          deleteCoupon(data).then((res) => {
            console.log("res", res);
            if (!res.isError) {
              this.$message({
                type: "success",
                message: res.errorMessage,
              });
              this.refreshCurrentList();
            } else {
              this.$message({
                type: "error",
                message: "删除失败",
              });
            }
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
    /**
     * @description: 删除或者恢复卡券申请记录
     * @param {*} row
     * @param {*} status
     * @return {*}
     */
    handleRemoveReqRecord(row, status) {
      const params = {
        CouponRequestID: row.CouponRequestID,
      };
      this.$confirm(`是否${status}该记录`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          switchCouponReqRecord(params).then((res) => {
            if (res.isError) {
              this.$message({
                type: "error",
                message: res.errorMessage,
              });
              this.refreshCurrentList();
            } else {
              this.$message({
                type: "success",
                message: `${status}成功！`,
              });
              this.refreshCurrentList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          });
        });
    },
    /**
     * @description: 删除或者恢复卡券赠送记录
     * @param {*} row
     * @param {*} status
     * @return {*}
     */
    handleRemoveSendRecord(row, status) {
      const params = {
        CouponSendRecordID: row.CouponSendRecordID,
      };
      this.$confirm(`是否${status}该记录`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          switchCardGiftRecord(params).then((res) => {
            if (res.isError) {
              this.$message({
                type: "error",
                message: res.errorMessage,
              });
              this.refreshCurrentList();
            } else {
              this.$message({
                type: "success",
                message: `${status}成功！`,
              });
              this.refreshCurrentList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-row {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 20px;
}
</style>
